import { onlyDigits } from '../only-digits/only-digits';

export function toUSPhone(phone: string): string | undefined {
  const cleanedNumber = onlyDigits(phone);
  const match = cleanedNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : undefined;
}
